import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-matrix-sort",
  "use": "foquz-icon-matrix-sort-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-matrix-sort\"><path d=\"M13 4l2.034-2m0 0L17 4m-1.966-2v16M4 8l.5-1m0 0L7 2l3 6M4.5 7h4.75M9 16v-4H6.234c-3 0-2.968 4 0 4M9 16v2m0-2H6.234m0 0h-.029L4.5 18\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol